export default __webpack_public_path__ + "static/media/spt18.05913d39.jpeg";